import { TimeType } from "../../utils/time/TimeType";

export class DurationFormatUtils {
    private static TIMETYPE_NAMES = TimeType.values.map(value => {
        return value.name;
    });
    private static REGEXP_PLACEHOLDER = /{(\w+)(?::(.*?))?}/g;

    public static placeholderReplacementsFrom(str: string): any {
        const result = {};
        let match;
        const pattern = /\{(.*?)\}/g;
        while ((match = pattern.exec(str)) !== null) {
            result[match[1]] = match[0];
        }
        return result;
    }

    public static get placeholderRegex() {
        return DurationFormatUtils.REGEXP_PLACEHOLDER;
    }

    public static get timeTypeNames() {
        return DurationFormatUtils.TIMETYPE_NAMES;
    }

    public static forAllPlaceholders(content, fn): any {
        let match;
        const placeholders = {};
        while ((match = DurationFormatUtils.placeholderRegex.exec(content))) {
            const placeholderName = match[1];
            const placeholderFormat = match[2] || "";
            placeholders[match[0]] = fn(placeholderName, placeholderFormat, match, content);
        }
        return placeholders;
    }

    public static replacePlaceholders(template, formatFn): string {
        const replacements = DurationFormatUtils.forAllPlaceholders(template, formatFn);
        let result = template;
        for (let replacement in replacements) {
            result = result.replace(replacement, replacements[replacement]);
        }
        return result;
    }
}
